import React from 'react';
import styled from 'styled-components';

import { ReactComponent as FreezingCycle } from '../../../assets/icons/freezing-cycle.svg';

import { typography } from '../../../styled';
import { themes } from 'kb-shared';
const { colors } = themes;
const {
  serif: {
    card: { H3 }
  },
  sans: {
    copy: { Nano }
  }
} = typography;

const Container = styled.div`
  background-color: ${colors.KBWhite};
  display: flex;
  padding: 20px 24px 28px 24px;
  width: calc(100% - 28px);
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Title = styled(H3)`
  margin: 0;
`;

const FreezingCycleIcon = styled(FreezingCycle)`
  height: 45px;
  margin-right: 10px;
  margin-top: -6px;
  width: 48px;
`;

type Props = {
  cycleCount: number;
  description: string;
  deposit?: boolean;
};

const BalanceExplainer = (props: Props) => {
  const { description, cycleCount, deposit } = props;
  let balanceString = 'Remaining balance';
  if (deposit) {
    balanceString = 'Deposit';
  }
  return (
    <Container>
      <FreezingCycleIcon />
      <ContentContainer>
        <Title>{`${balanceString} for ${cycleCount} cycle${cycleCount > 1 ? 's' : ''}`}</Title>
        {description && <Nano>{description}</Nano>}
      </ContentContainer>
    </Container>
  );
};

export default BalanceExplainer;
